export default {
  methods: {
    highlightFeature(layerId, featureId) {
      this.$store.set('map/ADD_SELECTED_FEATURES!', {
        type: 'highlitedFeatures',
        features: {
          [layerId]: [featureId],
        },
      });
    },
    clearHighlitedFeatureHandler(newLayerId, oldLayerId) {
      if (oldLayerId && oldLayerId !== newLayerId) {
        this.clearHighlitedFeature(oldLayerId);
        return;
      }
      this.clearHighlitedFeature(newLayerId);
    },
    clearHighlitedFeature(layerId = this.layer.id) {
      this.$store.set('map/DELETE_SELECTED_FEATURES!', {
        type: 'highlitedFeatures',
        features: {
          [layerId]: [],
        },
      });
    },
  },
};
